<template>
  <div>
    <b-modal
        v-model="modalActive"
        hide-footer
        id="modal-center"
        centered
        :title="$t('message.Education')">
      <b-form-group
          :label="$t('message.Name_uz')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="education.name_uz"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_ru')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="education.name_ru"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_en')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="education.name_en"
            required
        />
      </b-form-group>
      <b-form-group
          :label="$t('message.Name_kr')"
          label-for="name-input"
          invalid-feedback="Name is required"
      >
        <b-form-input
            id="name-input"
            v-model="education.name_kz"
            required
        />
      </b-form-group>
      <div
          style="margin-top: 30px; margin-left: 150px">
        <b-button
            variant="outline-primary"
            @click="handleClick"
        >{{$t('message.Cancel')}}
        </b-button>
        <b-button
            @click="handleSubmit"
            style="margin-left: 10px"
            variant="primary"
        >{{$t('message.Add')}}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>

import {addEducation, editEducation, getEducationById} from "../../../../../../api/education";

export default {
  name: "educationModal",
  props: {
    activeModal: {
      type: Boolean
    },
    id: {
      default: null,
    }
  },
  data(){
    return{
      education: {
        name_uz: '',
        name_ru: '',
        name_en: '',
        name_kz: ''
      },
    }
  },
  computed: {
    modalActive: {
      get() {
        return this.activeModal;
      },
      set(val) {
        if(!val) this.$emit('closeModal')
      }
    }
  },
  methods:{
    handleClick(){
      this.modalActive = false
    },
    fetchEducation(){
      getEducationById({ id: this.id}).then(response => {
        this.education = response.data.data
      })
    },
    handleSubmit() {
      if (this.education.name_uz
          && this.education.name_ru
          && this.education.name_en
          && this.education.name_kz) {
        if (this.id) {
          // eslint-disable-next-line no-unused-vars
          editEducation(this.education).then(res => {
            this.$emit('closeModal')
          })
        } else {
          // eslint-disable-next-line no-unused-vars
          addEducation(this.education).then(res => {
            this.$emit('closeModal')
          })
        }
      }
    },
  },
  watch: {
    id:{
      immediate: true,
      handler(val) {
        if(val) {
          this.fetchEducation()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>




